var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-filter", {
    attrs: {
      "status-options": _vm.statuses,
      "date-mode": "single",
      "show-team-members": true,
      "show-carriers": false,
      "show-customer-filter": true,
      clearable: false,
      "date-clearable": false,
      "use-in-map": true,
      "team-region-id": _vm.teamRegionId,
      "initial-filters": _vm.initialFilters,
      "status-test-id": "trip-status",
      "single-date-test-id": "trip-date",
      "single-date-class": "datepicker-container",
      "default-status": "All Statuses",
      domain: "trips",
    },
    on: { onFilterTrips: _vm.handleFilterTrips },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }